import { HouseholdSetupForm } from '@/features/household/HouseholdSetupForm'
import { JoinHouseholdForm } from '@/features/household/JoinHouseholdForm'

export function HouseholdSetupPage() {
  return (
    <main className="min-h-screen flex items-center justify-center bg-canvas p-4">
      <div className="w-full max-w-md space-y-4">
        <div className="text-center mb-2">
          <span className="text-3xl font-bold tracking-tight text-accent">mise</span>
        </div>
        <HouseholdSetupForm />
        <div className="flex items-center gap-3 px-1">
          <hr className="flex-1 border-line" />
          <span className="text-sm text-muted">or</span>
          <hr className="flex-1 border-line" />
        </div>
        <JoinHouseholdForm />
      </div>
    </main>
  )
}
